<template>
  <div class="page page-add">
    <div class="page-container">
      <div class="page-title">{{ wxMsgId ? '编辑' : '新增' }}推送消息</div>
      <div class="w1200">
        <div class="panel">
          <a-form-model ref="form" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <div class="panel-body">
              <a-row :gutter="0">
                <a-col span="24">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      推送主题
                    </span>
                    <a-input :auto-size="{ minRows: 4 }" v-model="form.first" placeholder="推送主题" ref="first"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      活动内容
                    </span>
                    <a-textarea :auto-size="{ minRows: 2 }" v-model="form.keyword1" placeholder="活动内容" ref="keyword1"></a-textarea>
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      活动进展
                    </span>
                    <a-textarea :auto-size="{ minRows: 1 }" v-model="form.keyword2" placeholder="描述活动当前状态，例如：进行中，邀请参与，评选中……" ref="keyword2"></a-textarea>
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false">
                    <span slot="label">备注</span>
                    <a-textarea :auto-size="{ minRows: 4 }" v-model="form.remark" placeholder="备注" ref="remark"></a-textarea>
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false">
                    <span slot="label">跳转链接</span>
                    <a-input v-model="form.url" placeholder="跳转链接" ref="url"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      通知用户
                    </span>
                    <div class="ant-transfer flex items-center">
                      <div class="ant-transfer-list col" style="height: 450px">
                        <div class="ant-transfer-list-header">
                          <a-checkbox :checked="unSelectedcheckedAll" :indeterminate="unSelectedIndeterminate" @change="onUnselectedCheckAllChange" />
                          <span class="ant-transfer-list-header-selected">
                            <span v-if="sourceList.some(item => item.checked)">{{ sourceList.filter(item => item.checked).length }} /</span>
                            <span>{{ sourceList.filter(item => !item.disabled).length }} 项</span>
                            <span class="ant-transfer-list-header-title">用户列表</span>
                          </span>
                        </div>
                        <div class="ant-transfer-list-body ant-transfer-list-body-with-search" style="padding-top: 44px">
                          <div class="ant-transfer-list-body-search-wrapper" style="padding: 8px 12px">
                            <div class="user-search-wrapper">
                              <a-input-search placeholder="用户名" v-model="searchKey" style="width: 100%" @search="handleSearch" />
                            </div>
                          </div>
                          <ul class="ant-transfer-list-content">
                            <template v-if="sourceList.length > 0">
                              <!-- LazyLoad -->
                              <li class="ant-transfer-list-content-item item-flex font-13 bg-grey-2">
                                <span class="ant-transfer-list-content-item-text">
                                  <span style="margin-left: 16px">用户</span>
                                  <span class="v-ml-auto">手机</span>
                                </span>
                              </li>
                              <div class="is-visible" style="height: 32px" v-for="item in sourceList" :key="item.id">
                                <li :title="item.realName" class="ant-transfer-list-content-item item-flex" @click="handleSwitchUser(item)" :class="{ 'ant-transfer-list-content-item-disabled': item.disabled }">
                                  <a-checkbox :checked="item.checked" :disabled="item.disabled" :class="{ 'ant-checkbox-wrapper-disabled': item.disabled }" />
                                  <span class="ant-transfer-list-content-item-text flex items-center">
                                    <a-icon class="text-green v-mr-xs" type="wechat" v-if="item.mp"></a-icon>
                                    <a-tag color="red" v-else>未关注公众号</a-tag>
                                    <span class="col ellipsis">{{ item.realName || item.userName }}</span>
                                    <span class="v-ml-auto">{{ item.phone }}</span>
                                  </span>
                                </li>
                              </div>
                            </template>
                            <div style="padding: 30px 0" v-if="!loading && sourceList.length === 0"><a-empty /></div>
                          </ul>
                        </div>
                      </div>
                      <div class="ant-transfer-operation col-auto">
                        <a-button size="small" type="primary" :disabled="!sourceList.some(item => item.checked)" icon="right" @click="handleTransferRight"></a-button>
                        <a-button size="small" type="primary" :disabled="!selectedList.some(item => item.checked)" icon="left" @click="handleTransferLeft"></a-button>
                      </div>
                      <div class="ant-transfer-list col" style="height: 450px">
                        <div class="ant-transfer-list-header">
                          <a-checkbox :checked="selectedcheckedAll" :indeterminate="selectedIndeterminate" @change="onSelectedCheckAllChange" />
                          <span class="ant-transfer-list-header-selected">
                            <span v-if="selectedList.some(item => item.checked)">{{ selectedList.filter(item => item.checked).length }} /</span>
                            <span>{{ selectedList.length }} 项</span>
                            <span class="ant-transfer-list-header-title">已选择用户</span>
                          </span>
                        </div>
                        <div class="ant-transfer-list-body">
                          <ul class="ant-transfer-list-content">
                            <template v-if="selectedList.length > 0">
                              <li class="ant-transfer-list-content-item item-flex font-13 bg-grey-2">
                                <span class="ant-transfer-list-content-item-text">
                                  <span style="margin-left: 16px">用户</span>
                                  <span class="v-ml-auto">手机</span>
                                </span>
                              </li>
                              <div class="is-visible" style="height: 32px" v-for="item in selectedList" :key="item.id" @click="item.checked = !item.checked">
                                <li :title="item.realName" class="ant-transfer-list-content-item item-flex">
                                  <a-checkbox :checked="item.checked" />
                                  <span class="ant-transfer-list-content-item-text flex items-center">
                                    <a-icon class="text-green v-mr-xs" type="wechat" v-if="item.mp"></a-icon>
                                    <span class="col ellipsis">{{ item.realName }}</span>
                                    <span class="v-ml-auto">{{ item.phone }}</span>
                                  </span>
                                </li>
                              </div>
                            </template>
                            <div style="padding: 30px 0" v-else><a-empty /></div>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model>
        </div>

        <a-affix :offset-bottom="10" :target="() => this.$refs.container">
          <div class="text-center v-mt-sm">
            <a-space>
              <a-button icon="save" :loading="saving" type="indigo" @click="handleConfirm(0)">保存初稿</a-button>
              <a-button icon="check" :loading="saving" type="primary" @click="handleConfirm(1)">保存并发布</a-button>
              <a-button icon="left" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </a-affix>
      </div>
    </div>
  </div>
</template>

<script>
import { saveWxMsg, getWxMsg } from '@/api/system/wxmsg'
import { listWxUser } from '@/api/user'
const form = {
  first: '',
  keyword1: '',
  keyword2: '',
  remark: '',
  url: '',
}

export default {
  data() {
    return {
      wxMsgId: undefined,
      type: undefined,
      form: {
        ...form,
      },
      searchKey: '',
      saving: false,
      loading: false,
      list: [],
      sourceList: [],
      selectedList: [],
    }
  },
  computed: {
    unSelectedcheckedAll() {
      let sourceList = this.sourceList.filter(item => !item.disabled)
      return sourceList.length > 0 && sourceList.filter(item => !item.checked).length === 0
    },
    unSelectedIndeterminate() {
      let sourceList = this.sourceList.filter(item => !item.disabled)
      let selList = sourceList.filter(item => item.checked)
      return sourceList.length > 0 && selList.length > 0 && selList.length < sourceList.length
    },
    selectedcheckedAll() {
      return this.selectedList.length > 0 && this.selectedList.filter(item => !item.checked).length === 0
    },
    selectedIndeterminate() {
      let sourceList = this.selectedList
      let selList = sourceList.filter(item => item.checked)
      return sourceList.length > 0 && selList.length > 0 && selList.length < sourceList.length
    },
  },
  methods: {
    init() {
      let { id, type } = this.$route.query
      if (type) {
        this.type = +type
      }
      if (id) {
        this.wxMsgId = +id
        this.loadWxMsg()
      } else {
        this.loadWxUsers()
      }
    },
    loadWxMsg() {
      getWxMsg(this.wxMsgId).then(({ data }) => {
        if (data.success) {
          let { content = '{}', userIds = '' } = data.result
          let body = JSON.parse(content)
          this.form = {
            first: body.first || '',
            keyword1: body.keyword1 || '',
            keyword2: body.keyword2 || '',
            remark: body.remark || '',
            url: body.url || '',
          }
          this.loadWxUsers(userIds.split(','))
        }
      })
    },
    loadWxUsers(selected = []) {
      let { type } = this
      listWxUser({ type }).then(({ data }) => {
        if (data.success) {
          let list = data.result
          list.forEach(item => {
            item.disabled = item.mp == 0 || selected.includes(`${item.id}`)
            item.checked = false
          })
          this.selectedList = list.filter(d => selected.includes(`${d.id}`))
          this.sourceList = list
        }
      })
    },
    handleSearch(value) {
      this.loading = true
      listWxUser({ name: value.trim() })
        .then(({ data }) => {
          if (data.success) {
            let records = data.result
            records.forEach(item => {
              item.disabled = this.selectedList.some(s => s.id === item.id) || item.mp == 0
              item.key = item.id
              item.checked = false
            })
            this.sourceList = records
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleUploadChange(info) {
      this.files = this.handleUploadFile(info, -1)
    },
    handleConfirm(nextStep) {
      let { first, keyword1, keyword2 } = this.form
      // let { expertList, voteList } = this
      this.$message.destroy()
      if (first.trim() === '') {
        this.$message.warning('请输入推送主题')
        this.$refs.first.focus()
        return
      }
      if (nextStep) {
        if (keyword1.trim() === '') {
          this.$message.warning('请输入活动内容')
          this.$refs.keyword1.focus()
          return
        }
        if (keyword2.trim() === '') {
          this.$message.warning('请输入活动进展')
          this.$refs.keyword2.focus()
          return
        }
        if (this.selectedList.length == 0) {
          this.$message.warning('请选择用户')
          return
        }
      }
      this.$confirm({
        title: nextStep ? '确认保存并发布？' : '确认保存草稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      this.$message.destroy()
      let { wxMsgId, type } = this
      let params = {
        wxMsgId,
        msgType: type,
        content: JSON.stringify(this.form),
        userIds: this.selectedList.map(d => d.id).join(','),
        nextStep,
      }
      this.saving = true
      saveWxMsg(params)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.wxMsgId = data.result
            this.$router.go(-1)
          } else {
            this.$message.error('操作失败')
          }
          this.saving = false
        })
        .catch(() => {
          this.$message.error('操作失败')
        })
    },
    handleSwitchUser(item) {
      if (!item.disabled) {
        item.checked = !item.checked
      }
    },
    handleTransferRight() {
      this.selectedList = [...this.selectedList, ...this.sourceList.filter(item => item.checked).map(item => ({ ...item, checked: false }))]
      this.sourceList.forEach(item => {
        item.disabled = this.selectedList.some(s => s.id === item.id) || item.mp == 0
        item.checked = false
      })
    },
    handleTransferLeft() {
      this.sourceList.forEach(item => {
        let target = this.selectedList.find(s => s.id === item.id)
        item.disabled = item.mp == 0 || item.binded === 1 || (target && !target.checked)
      })
      this.selectedList = this.selectedList.filter(item => !item.checked)
    },
    onUnselectedCheckAllChange(e) {
      this.sourceList.forEach(item => {
        item.checked = !item.disabled && e.target.checked
      })
    },
    onSelectedCheckAllChange(e) {
      this.selectedList.forEach(item => {
        item.checked = e.target.checked
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus">
.form-class{
    background-color: #f4f4fa;
    padding: 20px;
    border-radius: 3px;
    margin-bottom: 20px;
}
</style>
